export default __webpack_public_path__ + "static/media/pm25.e4d04481.svg";